import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionComponent } from '../components/question/question.component';
import { FaqsComponent } from '../components/faqs/faqs.component';
import { FormatStringPipe } from 'src/app/common/format-string.pipe';
import { ResultComponent } from '../components/result/result.component';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SpinnerComponent } from '../components/spinner/spinner.component';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { ChatMenuComponent } from '../components/chat-menu/chat-menu.component';
import { UserLogoComponent } from '../components/user-logo/user-logo.component';
import { OrgLogoComponent } from '../components/org-logo/org-logo.component';
import { MenuButtonComponent } from '../components/buttons/menu-button/menu-button.component';
import { SubmitComponent } from '../components/buttons/submit/submit.component';
import { EllipsisDirective } from 'ngx-ellipsis';
import { UserProfileComponent } from '../components/user-profile/user-profile.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PowerBiEmbedComponent } from '../embed/power-bi-embed/power-bi-embed.component';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';
import { PromptMenuComponent } from '../components/prompt-menu/prompt-menu.component';
import { EditPromptComponent } from '../components/edit-prompt/edit-prompt.component';
import { FilterPanelComponent } from '../components/filter-panel/filter-panel.component';
import {MatTabsModule} from '@angular/material/tabs';
import { ProcessTypeComponent } from '../components/process-type/process-type.component';

@NgModule({
  declarations: [QuestionComponent,FaqsComponent,ResultComponent, FormatStringPipe,SpinnerComponent,ChatMenuComponent,UserLogoComponent,OrgLogoComponent,MenuButtonComponent,SubmitComponent,UserProfileComponent,PowerBiEmbedComponent,PromptMenuComponent,EditPromptComponent,FilterPanelComponent,ProcessTypeComponent,],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    AngularFireModule ,
    AngularFireAuthModule ,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatMenuModule,
    MatTooltipModule ,
    MatFormFieldModule, MatInputModule, MatSelectModule,
    EllipsisDirective,
    MatCardModule, MatCheckboxModule, MatRadioModule,
    MatTabsModule  ],
  exports:[QuestionComponent,FaqsComponent,ResultComponent, FormatStringPipe,SpinnerComponent,ChatMenuComponent,UserLogoComponent,OrgLogoComponent,MenuButtonComponent,SubmitComponent,UserProfileComponent,PowerBiEmbedComponent,PromptMenuComponent,EditPromptComponent,FilterPanelComponent,ProcessTypeComponent,]
})
export class SharedModule { }
